import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { CellClassRules, ColDef, ColumnApi, GridApi, GridOptions, SideBarDef } from 'ag-grid-enterprise';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { ReportService } from '../..';
import 'ag-grid-enterprise';

@Component({
    selector: 'app-res-sales-report',
    templateUrl: './res-sales-report.component.html',
    styleUrls: ['./res-sales-report.component.css'],
    standalone: false
})
export class ResSalesReportComponent implements OnInit, AfterViewInit {

	@Input() showSearchUI = true;
	@Input() resRevByDay: any = [];

	// forms
	formLoading = false;
	currentSearchForm: any;
	defaultStartDate: Date
	defaultEndDate: Date
	defaultReservationStatuses: any;
	defaultShortTermRentalIds: any;

	// ag-grid
	gridApi: GridApi;
	columnApi: ColumnApi;
	gridOptions: GridOptions = {};

	// color rules
	occupancyNtsCellClassRule: CellClassRules = this.reportService.occupancyNtsCellClassRule;
	occupancyPctCellClassRule: CellClassRules = this.reportService.occupancyPctCellClassRule;

	autoGroupColumnDef = {
		headerName: 'Date',
		cellRendererParams: {
			suppressCount: true,
			// checkbox: true,
		}
	};

	defaultColDef: ColDef = {
		sortable: true,
		filter: true,
	};



	columnDefsOld = [
		{ headerName: 'Year', field: 'year', rowGroup: true, hide: false, valueGetter: this.reportService.getYearFromSaleDate },
		{ headerName: 'Month', field: 'date', rowGroup: true, hide: false, valueGetter: this.reportService.getMonthFromSaleDate },
		/*{ headerName: 'Day', field: 'date', rowGroup: true, hide: false, valueGetter: this.reportService.getDayFromSaleDate },*/
		{ headerName: 'Property', field: 'propertyCode', rowGroup: false },
		{ headerName: 'ReservationId', field: 'reservationId', valueGetter: this.reportService.getGuestName },
		{ headerName: 'Occ Nts ##', field: 'numNightsTTL', aggFunc: 'sum' },
		{ headerName: 'Occ Nts %', valueGetter: this.reportService.getRentedPercent, cellRenderer: this.reportService.percentCellRenderer, aggFunc: 'sum' },
		{ headerName: 'Occ Nts Guest', field: 'numNtsGuestTTL', aggFunc: 'sum' },
		{ headerName: 'Rate PNT', field: 'revRoomRateNetPNT', cellRenderer: this.reportService.currencyCellRendererUSD, aggFunc: 'avgAggFunction' },
		{ headerName: 'Rate TTL', field: 'revRoomRateNetPNT', cellRenderer: this.reportService.currencyCellRendererUSD, aggFunc: 'sum' },
		{ headerName: 'Comm TTL', field: 'revCommissionPNT', cellRenderer: this.reportService.currencyCellRendererUSD, aggFunc: 'sum' },
		{ headerName: 'Resort TTL', field: 'revResortPNT', cellRenderer: this.reportService.currencyCellRendererUSD, aggFunc: 'sum' },
		{ headerName: 'Dmg TTL', field: 'revDamageWaiverPNT', cellRenderer: this.reportService.currencyCellRendererUSD, aggFunc: 'sum' },
		{ headerName: 'Hskp TTL', field: 'revHousekeepingPNT', cellRenderer: this.reportService.currencyCellRendererUSD, aggFunc: 'sum' },
	];


	columnDefs = [
		{ headerName: 'Year', field: 'year' },
		{ headerName: 'Month', field: 'date' },
		{ headerName: 'Property', field: 'propertyCode' },
		{ headerName: 'ReservationId', field: 'reservationId' },
		{ headerName: 'Occ Nts ##', field: 'numNightsTTL' },
	];


	constructor(
		public messageService: MessageService,
		public reportService: ReportService) { }


	ngOnInit(): void {
		this.defaultStartDate = new Date();
		// this.defaultStartDate = new Date(this.defaultStartDate.getFullYear()-4, this.defaultStartDate.getMonth(), 1);
		this.defaultStartDate = new Date(this.defaultStartDate.getFullYear(), 0, 1); // jan 1
		this.defaultEndDate = new Date();
		this.defaultEndDate = new Date(this.defaultEndDate.getFullYear(), 0, 2);

		this.defaultReservationStatuses = ['OP', 'OO', 'OG'];
		this.defaultShortTermRentalIds = [1];

		// ag-grid
		this.gridOptions.rowData = this.resRevByDay;
		this.gridOptions.columnDefs = this.columnDefs;
		this.gridOptions.autoGroupColumnDef = this.autoGroupColumnDef;
		this.gridOptions.pagination = true;
		this.gridOptions.suppressAggFuncInHeader = true;
		// pivotMode was true but the active columnDefs have no pivot/rowGroup columns,
		// causing ag-grid to show a perpetual loading state. Removed.
		this.gridOptions.animateRows = true;
		this.gridOptions.defaultColDef = this.defaultColDef;

		// https://www.ag-grid.com/javascript-data-grid/column-sizing/
		// this.gridOptions.suppressColumnVirtualisation = true;
	}



	ngAfterViewInit(): void {
		this.gridOptions.animateRows = true;
		(this.gridOptions as any).api?.setColumnDefs(this.columnDefs);
	}


	onGridReady(grid: any): void {
		this.gridApi = grid;
		this.columnApi = grid.columnApi;
	}


	onFirstDataRendered(params: any): void {
		setTimeout(() => { this.columnApi.autoSizeAllColumns(); }, 2000);
	}

	onRowGroupOpened(event) {
		this.columnApi.autoSizeAllColumns();
	}

	onSearchSubmit(searchForm: any) {
		this.currentSearchForm = searchForm;
		this.runReservationRevenueReport(searchForm);
	}

	runReservationRevenueReport(searchForm: any) {
		try {
			this.formLoading = true;
			this.reportService.reservationRevenueReport(searchForm)
				.subscribe(
					res => {
						console.log('runReservationRevenueReport SUCCESS: ' + JSON.stringify(res));
						this.resRevByDay = res.data.resRevenues.resRev;
						this.columnApi.autoSizeAllColumns();
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message, life: 3000 });
					},
					err => {
						console.log('runReservationRevenueReport FAIL: ' + JSON.stringify(err));
						this.formLoading = false;
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.formLoading = false;
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: runReservationRevenueReport' });
		}
	}
}
